/**
 * Document Utilities
 * Text extraction from parsed document structures
 */

/**
 * Parsed document content for text extraction
 * Compatible with ParsedDocument from document-parser.ts
 */
export interface ParsedDocumentContent {
  paragraphs?: Array<{ text?: string }>;
  sentences?: Array<{ text?: string }>;
  words?: Array<{ text?: string }>;
  text?: string;
}

/**
 * Extract plain text from a parsed document structure
 * Tries paragraphs first (highest quality), then sentences, words, and raw text
 * @param parsed - Parsed document object
 * @returns Extracted plain text
 */
export function extractDocumentText(
  parsed: ParsedDocumentContent | null
): string {
  if (!parsed) {
    return '';
  }

  // Try paragraphs first (highest quality)
  if (parsed.paragraphs && Array.isArray(parsed.paragraphs)) {
    return parsed.paragraphs.map((para) => para.text || '').join('\n');
  }

  // Fall back to sentences
  if (parsed.sentences && Array.isArray(parsed.sentences)) {
    return parsed.sentences.map((sent) => sent.text || '').join(' ');
  }

  // Fall back to words
  if (parsed.words && Array.isArray(parsed.words)) {
    return parsed.words.map((word) => word.text || '').join(' ');
  }

  // Fall back to raw text
  return parsed.text || '';
}
